import { forkJoin } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { AppointmentCalendarType, AppointmentDayEvent, AppointmentDayEventType } from 'projects/admin/src/app/partials/data/appointments/appointment-calendar/appointment-calendar.component';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { AppointmentModel } from 'projects/core/src/lib/models/appointment.model';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';
import { LocationModel } from 'projects/core/src/lib/models/location.model';

@Component({
  selector: 'app-my-availabilities',
  templateUrl: './my-availabilities.component.html',
  styleUrls: ['./my-availabilities.component.scss']
})
export class MyAvailabilitiesComponent implements OnInit {

  public setup: { [key: string]: string };
  public days: Array<AppointmentModel> = [];
  public specialdays: Array<AppointmentModel> = [];
  public reset: Array<AppointmentModel> = [];
  public observers: Array<any> = [];
  public locations: Array<LocationModel> = [];
  public loading = true;
  public submitting = false;
  public inEdit = false;
  public isModerator = false;
  public introText: string = null;

  public AppointmentCalendarType = AppointmentCalendarType;

  constructor(
    private api: ApiService,
    private auth: AuthStateService,
    private transloco: TranslocoService
  ) { }

  ngOnInit(): void {
    this.isModerator = this.auth.hasRole('moderator') || this.auth.hasRole('moderator_external');
    const endpoints = [
      this.api.getAppointmentSetup(),
      this.api.getAvailabilities()
    ];
    if (this.isModerator) {
      endpoints.push(this.api.getAppointmentObservers());
    }
    forkJoin(endpoints).subscribe({
      next: (result: any) => {
        if (result[0].data) {
          this.setup = result[0].data;
          this.specialdays = this.getDaysAsModel(result[0].data.days);
          this.locations = result[0].data.mydata?.locations?.map((location: any) => {
            return new LocationModel().deserialize(location);
          });
          this.setIntroText();
        }
        if (result[1].data) {
          this.reset = result[1].data;
          this.days = this.getDaysAsModel(result[1].data);
        }
        if (this.isModerator && result[2].data) {
          this.observers = result[2].data;
        }
      }
    }).add(() => {
      this.loading = false;
    });
  }

  public onEdit(): void {
    this.inEdit = true;
  }

  public onCancel(): void {
    this.days = this.getDaysAsModel([...this.reset]);
    this.inEdit = false;
  }

  public onSubmit(): void {
    this.submitting = true;
    const payload = this.days.map((day: AppointmentModel) => {
      return day.getPayloadForSaving();
    });
    this.api.saveAppointments('availabilities', payload).subscribe({
      next: (result: any) => {
        this.reset = [...result.data];
        this.days = this.getDaysAsModel(result.data);
      }
    }).add(() => {
      this.submitting = false;
      this.inEdit = false;
    });
  }

  public onDayChange(event: AppointmentDayEventType) {
    if (event.event === AppointmentDayEvent.Create) {
      this.days = [...this.days, event.day];
    } else if (event.event === AppointmentDayEvent.Delete) {
      this.days = this.days.filter(day => day.day !== event.day.day);
    }
    this.days.sort((a: AppointmentModel, b: AppointmentModel) => {
      return (a.day > b.day) ? 1 : ((b.day > a.day) ? -1 : 0);
    });
  }

  private getDaysAsModel(days: Array<any>): Array<AppointmentModel> {
    return days.map((day: any) => {
      const appointment = new AppointmentModel().deserialize(day);
      appointment.setTranslocoService(this.transloco);
      return appointment;
    });
  }

  private setIntroText(): void {
    const id = (this.isModerator === true) ? 'moderator_info_calendar' : 'observer_info_calendar';
    const lang = this.transloco.getActiveLang().toUpperCase();
    this.introText = this.setup.texts[id][lang] || null;
  }

}
